import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import { login, LoginRequest, getInfo } from "@/apis/user";
import {
  getToken,
  setToken,
  removeToken,
  setTokenTimeout,
  removeTokenTimeout
} from "@/utils/auth";
import store from "@/store";
type IUser = {
  token: string;
  customerId: string;
  mobile: string;
  nickname: string;
  avatar: string;
  status: string;
  isSpokenStatus: string;
};
@Module({ dynamic: true, store: store, name: "user" })
export default class User extends VuexModule implements IUser {
  token = getToken();
  customerId = "";
  mobile = "";
  nickname = "";
  rolename = "";
  avatar = "";
  status = "";
  isSpokenStatus = ""; //代言人的状态11，12，13为线下代理

  /** 用户评论是否被禁言 */
  isBlack = false;

  @Mutation
  SET_CUSTOMER_ID(customerId: string) {
    this.customerId = customerId;
  }
  @Mutation
  SET_MOBILE(mobile: string) {
    this.mobile = mobile;
  }
  @Mutation
  SET_TOKEN(token: string) {
    this.token = token;
  }
  @Mutation
  SET_NICKNAME(nickname: string) {
    this.nickname = nickname;
  }
  @Mutation
  SET_ROLENAME(name: string) {
    this.rolename = name;
  }
  @Mutation
  SET_AVATAR(avatar: string) {
    this.avatar = avatar;
  }
  @Mutation
  SET_STATUS(status: number) {
    if (status == 0) {
      this.status = "游客";
    } else if (status == 1) {
      this.status = "学员";
    } else if (status == 2) {
      this.status = "代言人";
    } else if (status == 3) {
      this.status = "学习委员";
    } else if (status == 11) {
      this.status = "主任";
    } else if (status == 10) {
      this.status = "子代理";
    } else if (status == 12) {
      this.status = "院长";
    } else if (status == 13) {
      this.status = "校长";
    }
    this.isSpokenStatus = status.toString();
  }
  @Mutation
  SET_IS_BLACK(isBlack: boolean) {
    this.isBlack = isBlack;
  }
  @Action({ rawError: true })
  async Login(data?: LoginRequest) {
    let resData = null;

    resData = await login(data as LoginRequest);

    setToken(resData.token);
    setTokenTimeout(resData.timeout);
    this.context.commit("SET_TOKEN", resData.token);
    return resData;
  }

  @Action
  Logout() {
    removeToken();
    removeTokenTimeout();
    this.context.commit("SET_TOKEN", "");
  }

  @Action({ rawError: true })
  async GetInfo() {
    // const {
    //   customer_id,
    //   mobile = "",
    //   nickname = "",
    //   avatar = "",
    //   status = "",
    //   role_name = ""
    // } =
    let data = await getInfo(0); // maybe 返回null
    let customer_id = data && data.customer_id ? data.customer_id : "";
    let mobile = data && data.mobile ? data.mobile : "";
    let nickname = data && data.nickname ? data.nickname : "";
    let avatar = data && data.avatar ? data.avatar : "";
    let status = data && data.status ? data.status : "";
    let role_name = data && data.role_name ? data.role_name : "";

    if (customer_id) this.context.commit("SET_CUSTOMER_ID", customer_id);
    if (mobile) this.context.commit("SET_MOBILE", mobile);
    if (nickname) this.context.commit("SET_NICKNAME", nickname);
    if (avatar) this.context.commit("SET_AVATAR", avatar);
    if (status) this.context.commit("SET_STATUS", status);
    if (role_name) {
      this.context.commit("SET_ROLENAME", role_name);
    }
  }

  @Action
  UpdateToken(token: string) {
    this.context.commit("SET_TOKEN", token);
  }

  @Action
  UpdateMobile(mobile: string) {
    this.context.commit("SET_MOBILE", mobile);
  }
  @Action
  UpdateNickname(nickname: string) {
    this.context.commit("SET_NICKNAME", nickname);
  }
  @Action
  UpdateAvatar(avatar: string) {
    this.context.commit("SET_AVATAR", avatar);
  }
  @Action
  UpdateStatus(status: string) {
    this.context.commit("SET_STATUS", status);
  }
  @Action
  UpdateIsBlack(isBlack: boolean) {
    this.context.commit("SET_IS_BLACK", isBlack);
  }
}

export const UserModule = getModule(User);
